/**
 * OAuth configuration constants
 * These GUIDs are hardcoded in the legacy dataProtect application
 */

export const OAUTH_TYPE_GUIDS = {
  SALESFORCE: '9090b61412a74d97ad9ed02c5fx7e705',
  DOCUSIGN: 'f249774c-4731-48f7-9fbd-0d79f241fcb2',
  // BVA/Zoom/Canvas use provider-specific OAuth flows without type GUIDs
  // The backend routes these based on provider type in the URL path
  BVA: 'BrightSpaceValenceApi',
  ZOOM: 'Zoom',
  CANVAS: 'CanvasOAuth2',
} as const;

export const OAUTH_POPUP_CONFIG = {
  WIDTH: 600,
  HEIGHT: 600,
} as const;
